var React = require('react');

function HamburgerMenuInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#1D7A70","fillRule":"nonzero","d":"M40.5 32a2.5 2.5 0 0 1 .164 4.995L40.5 37h-38a2.5 2.5 0 0 1-.164-4.995L2.5 32h38zm0-16a2.5 2.5 0 0 1 .164 4.995L40.5 21h-38a2.5 2.5 0 0 1-.164-4.995L2.5 16h38zm0-16a2.5 2.5 0 0 1 .164 4.995L40.5 5h-38A2.5 2.5 0 0 1 2.336.005L2.5 0h38z"}));
}

HamburgerMenuInline.defaultProps = {"width":"43","height":"37","viewBox":"0 0 43 37"};

module.exports = HamburgerMenuInline;

HamburgerMenuInline.default = HamburgerMenuInline;
